var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container text-center"},[_c('h3',[_vm._v(_vm._s(_vm.config.blogTitle))]),_c('p',[_c('i',[_vm._v(_vm._s(_vm.config.description))])]),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }